export const excludeUrls = [
	'/rser',
	'/bilogs',
	'/appkeysearch',
	'/updategcm',
	'/fustl',
	'/initauth',
	'/ofhs',
	'/frecopt',
	'/getlistissueddoc',
	'/ip',
  ];